import { defineStore } from 'pinia'
import axios from 'axios'
import {reactive,ref} from 'vue'

export const useTeamStore = defineStore('TeamStore', {
    state: () => {
        return {
            team: reactive({}),
            clients: reactive({}),
            permissions: reactive({}),
            labels: reactive({}),
        }
    },
    actions: {
        async fetchTeam() {
            try {
                this.team = await axios.post(`${baseUrl}/admin/team`)
                .then(function (response) {
                    return response.data.data;
                });
            } catch (error) {
            }
        },
    }
})
